import { render, staticRenderFns } from "./ActionScrubs.vue?vue&type=template&id=177121e6&scoped=true"
import script from "./ActionScrubs.vue?vue&type=script&lang=js"
export * from "./ActionScrubs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177121e6",
  null
  
)

export default component.exports